const isoLangOptions = {
  'hk': 'zh-hk',
  'cn': 'zh-cn',
  'en': 'en-hk'
};

export default isoLangOptions;
